import { Component } from "react";

/**
 * Convenient way of embedding given Backbone-models into a React view.
 * @see https://itnext.io/using-backbonejs-successfully-with-react-using-mobx-666eceb079f6
 *
 * @todo Implement "global template namespace", i.e. https://reactjs.org/docs/context.html#reactcreatecontext
 *       that can be used elsewehere like const { t,rbac } = [...?]this.context
 * @todo Find better naming
 */
export default class InboomaReactModelView extends Component {
  constructor(...props) {
    super(...props);

    if (this.props.model) {
      this.state = {
        model: this.props.model,
      };

      this.model = this.state.model;

      // When using e.g. mobx observer we could erase the next lines
      this.model.on(
        "change", // or something existing, ~ this.modelEvents
        (model) => this.setState({ model }),
      );
    }
  }
}
